import { isEmulatorMode } from 'firebase-utils/firebase';

export interface EnvBadge {
  label: string;
  color: string;
}

/**
 * Returns environment badges to display based on current mode and emulator status.
 * Returns empty array for production mode.
 */
export function getEnvironmentBadges(): EnvBadge[] {
  const badges: EnvBadge[] = [];
  const mode = import.meta.env.MODE;

  // Add environment badge (dev/staging)
  if (mode === 'development') {
    badges.push({ label: 'DEV', color: 'yellow' });
  } else if (mode === 'staging') {
    badges.push({ label: 'STAGING', color: 'orange' });
  } else if (mode === 'production') {
    badges.push({ label: 'PRODUCTION', color: 'blue' });
  }
  // Production mode: no environment badge

  // Add emulator badge if emulators are active
  if (isEmulatorMode) {
    badges.push({ label: 'EMULATOR', color: 'red' });
  }

  return badges;
}
